import React from 'react';
import UsersDetails from 'components/users/Details';
import {Button} from 'react-bootstrap'

export default props => {
  return (
    <div>
      <Button bsStyle="danger" className="pull-right" onClick={props.selectOne()}>Close</Button>
      <h2>Indepth: User</h2>
      <UsersDetails {...props} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/users/Indepth.jsx